import { render } from "./trainingVideoAdmin.vue?vue&type=template&id=ac3023b2&scoped=true"
import script from "./trainingVideoAdmin.vue?vue&type=script&lang=js"
export * from "./trainingVideoAdmin.vue?vue&type=script&lang=js"

import "./trainingVideoAdmin.vue?vue&type=style&index=0&id=ac3023b2&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac3023b2"]])

export default __exports__